<script>
import Vue from 'vue'
import WDatepicker from '../../Forms/WDatepicker/WDatepicker.vue'
import WButton from '../../WButton/WButton.vue'

export default Vue.extend({
    name: 'DateCellEditor',
    components: {
        WDatepicker,
        WButton,
    },
    data () {
        return {
            name: 'select',
            inputValue: false,
            disabled: false,
            popoverDirection: 'right',
        }
    },
    created () {
        const {
            value, name, disabled, popoverDirection, column, node,
        } = this.params
        this.inputValue = value ? new Date(value) : ''

        if (name) this.name = name
        if (disabled) this.disabled = disabled
        this.popoverDirection = popoverDirection || this.calcPopoverDirection(node, column)
    },
    methods: {
        getValue () {
            return this.inputValue.toISOString()
        },
        isPopup () {
            return true
        },
        handleInput (value) {
            this.inputValue = value
        },
        handleClick (happy) {
            this.params.api.stopEditing()
        },
        calcPopoverDirection (node, column) {
            const MIN_SIZE = 335
            if (node.rowTop >= MIN_SIZE) return 'top'
            return column.left >= MIN_SIZE ? 'left' : 'right'
        },
    },
    render (h) {
        return h(
            'div',
            {
                class: 'DateCellEditor EditorPopup flex row-center-top',
            },
            [
                h(WDatepicker, {
                    props: {
                        name: this.name,
                        value: this.inputValue,
                        placeholder: this.placeholder,
                        disabled: this.disabled,
                        popoverDirection: this.popoverDirection,
                    },
                    on: {
                        input: this.handleInput,
                    },
                }),
                h(WButton, {
                    props: {
                        iconLeft: 'save',
                        iconSize: 16,
                    },
                    on: {
                        click: this.handleClick,
                    },
                }),
            ],
        )
    },
})
</script>
